import gql from "graphql-tag";

export default {
  mutation: gql`
    mutation editProcessingUserAccess(
      $id: ID!
      $username: String!
      $hasAccess: String!
    ) {
      changeProcessingUserAccess(
        id: $id
        username: $username
        hasAccess: $hasAccess
      ) {
        success
      }
    }
  `,
  mutationName: "editProcessingUserAccess",
};



// WEBPACK FOOTER //
// ./src/model/gql/mutations/users/processingUser/access/editUserAccess.js